import styled, { css } from 'styled-components'

import { PatternFormat } from 'react-number-format'

export const Container = styled.div`
  width: ${({ $size }) => ($size ? `${$size}px` : '100%')};
  height: 50px;

  background: inherit;

  padding: 10px;

  border: 0;
  outline: none;

  display: flex;
  align-items: center;
  gap: 10px;

  border-bottom: 1px solid #f3f3f3;

  ${({ $isFocused }) =>
    $isFocused &&
    css`
      border-bottom: 1px solid #06357a;
    `}
`

export const StyledInput = styled(PatternFormat)`
  flex: 1;
  height: 100%;
  font-size: 16px;
  background: inherit;

  border: 0;
  outline: none;

  ${({ $isFocused }) =>
    $isFocused &&
    css`
      &::placeholder {
        color: #06357a;
      }
    `}
`
